import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';

const instaviewBaseUrl = `${envConfig('b2BucketUrl')}/instaview`;
const homiqBaseUrl = `${envConfig('b2BucketUrl')}/homiq`;

export const assets: TPartnerAssets = {
  logo: `${homiqBaseUrl}/logo.svg`,
  loginIllustration: `${homiqBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${instaviewBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${instaviewBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${homiqBaseUrl}/attention.svg`,
  basicAlertsIcon: `${homiqBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${instaviewBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${homiqBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${instaviewBaseUrl}/decriptiveAIAlertsIcon.svg`,
  descriptiveAIAlertsImg: `${instaviewBaseUrl}/descriptiveAIAlerts.png`,
  firmwareVersionIcon: `${homiqBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${homiqBaseUrl}/interntNotConnected.svg`,
  limitedSecurityImg: `${instaviewBaseUrl}/limitedSecurity.png`,
  limitedSecurityIcon: `${homiqBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${homiqBaseUrl}/location.svg`,
  logoContrastIcon: `${homiqBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${homiqBaseUrl}/logoWhite.svg`,
  maxCameraLimitReachedIcon: `${instaviewBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${homiqBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosImg: `${instaviewBaseUrl}/noEventVideos.png`,
  noEventVideosIcon: `${homiqBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${homiqBaseUrl}/paymentFailedIcon.svg`,
  paymentSuccessfulIcon: `${homiqBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${homiqBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${homiqBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${homiqBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${homiqBaseUrl}/professionMonitoringIcons.svg`,
  professionalMonitoringImg: `${instaviewBaseUrl}/professionalMonitoring.png`,
  sampleCreditCardIcon: `${homiqBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${homiqBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${homiqBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${homiqBaseUrl}/wifiIcon.svg`,
  appQRCode: `${homiqBaseUrl}/qrCode.png`
};
